export default __webpack_public_path__ + "static/media/two.c1f4774c.jpeg";